export const useStoreStreamChat = defineStore('StoreStreamChat', {
    state: () => ({
        token: null,
        stream: null,
        message: null,
        messages: [],
        connection: null,
        error: null,
    }),
    actions: {
        initChat ({token, streamSlug}) {
            if (this.connected && token === this.token) return;
            this.setChat({token, streamSlug});
            if (this.connected) {
                this.connection.close();
            }
            const $config = useRuntimeConfig();
            const connection = new WebSocket($config.public.chats, token);
            connection.addEventListener("error", (event) => {
                console.log("Chat websocket error: ", event);
                setTimeout(() => {
                    let storeStreams = useStoreStreams();
                    storeStreams.getStreams();
                }, 10000);
            });
            connection.addEventListener(
                'message',
                (e) => this.websocketMessageReceived(e)
            );
            this.connection = connection;
        },
        websocketMessageReceived (event) {
            const data = JSON.parse(event.data);
            if (data?.Type === 'EVENT' && data?.EventName === 'aws:DELETE_MESSAGE') {
                return this.deleteMessage(data);
            } else if (data?.Type === 'MESSAGE') {
                return this.receiveMessage(data);
            } else {
                console.error('Some other event occurred!');
                console.log(event.data);
            }
        },
        receiveMessage (data) {
            const message = {
                message: data.Content,
                timestamp: data.SendTime,
                data: data,
                id: data.Id,
                user: data.Sender.Attributes.first_name,
                thumb: data.Sender.Attributes.profile_thumb
            };
            this.messages.push(message);
        },
        deleteMessage (data) {
            this.messages = this.messages.filter(message => message.id !== data.Attributes.MessageID);
        },
        updateMessageField ({field, value}) {
            if (field === 'message') return this.message = value;
            console.error('Attempted to update a field that doesn\'t exist');
        },
        sendMessage () {
            if (!this.message) return;
            const payload = {
                'Action': 'SEND_MESSAGE',
                'Content': this.message,
            };
            this.connection.send(JSON.stringify(payload));
            this.message = null;
        },
        setChat ({token, streamSlug}) {
            this.token = token;
            if (this.stream !== streamSlug) this.messages = [];
            this.stream = streamSlug;
            if (!this.messages.length) {
                this.messages = [
                    {
                        'message': 'Welcome to the live...',
                        'data': {'Sender': {'UserId': '0'}},
                        'user': 'Andy Guitar',
                    },
                    {
                        'message': 'Join the chat!',
                        'data': {'Sender': {'UserId': '0'}},
                        'user': 'Andy Guitar',
                    },
                ];
            }
        },
    },
    getters: {
        connected () {
            return !!this.connection;
        },
    },
});
